const FALLBACK_MIME_TYPE = 'application/octet-stream'

const MIME_BY_EXTENSION: Record<string, string> = {
  avif: 'image/avif',
  csv: 'text/csv',
  gif: 'image/gif',
  heic: 'image/heic',
  heif: 'image/heif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  json: 'application/json',
  md: 'text/markdown',
  pdf: 'application/pdf',
  png: 'image/png',
  svg: 'image/svg+xml',
  txt: 'text/plain',
  webp: 'image/webp',
}

export const getUploadContentType = (file: File): string => {
  if (file.type) {
    return file.type
  }

  const extension = file.name.split('.').pop()?.toLowerCase()
  return extension
    ? MIME_BY_EXTENSION[extension] ?? FALLBACK_MIME_TYPE
    : FALLBACK_MIME_TYPE
}
